import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {Box, Button, IconButton, styled} from "@mui/material";
import React from "react";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";

const FooterContainer = styled(Box)({
    position: "relative",
    height: "60px",
    width: "100%",
    background: "#121212",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    boxSizing: "border-box",
});

const FooterLink = styled(Button)({
    color: "#FFFFFF",
    textTransform: "none",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    textDecoration: "underline",
    textShadow: "none",
    transition: "background 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55), transform 0.3s ease-out",
    "&:hover":{
        background: "rgba(0, 0, 0, 0.6)",
        transform: "scale(1.05)",
    },
    "@media(max-width: 768px)":{
        fontSize: "0.6rem",
    },
});

const Footer = ():JSX.Element => {
    
    return <FooterContainer>
        <IconButton href={"#intro"} sx={{
            zIndex: 2,
            transition: "transform 0.3s ease-out",
            "&:hover":{
                boxShadow:"0 0 15px #ffc371",
                transform: "scale(1.1)",
            },
        }}>
            <KeyboardDoubleArrowUpIcon htmlColor={"#FFFFFF"}/>
        </IconButton>
        <FooterLink  onClick={() => window.open("https://www.linkedin.com/company/insight-questor/")}>
            {window.innerWidth > 768 && <LinkedInIcon htmlColor={"#FFFFFF"}/>}
            Company on LinkedIn
            {window.innerWidth > 768 && <DoubleArrowIcon htmlColor={"#FFFFFF"}/>}
        </FooterLink>
        <FooterLink  onClick={() => window.open("https://tietopalvelu.ytj.fi/yritys/3480071-9")}>
            {window.innerWidth > 768 && <BusinessCenterIcon htmlColor={"#FFFFFF"}/>}
            BusinessID(Finland): 3480071-9
            {window.innerWidth > 768 && <DoubleArrowIcon htmlColor={"#FFFFFF"}/>}
        </FooterLink>
    </FooterContainer>;
};

export default Footer;
